import React from "react";
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { Link } from "react-router-dom";
import Button from "../../../Parts/Button";
import {
  DialogType,
  SalesforceSettingDirectory,
} from "../../../../constants/ComponentTypes";

const styles = () => ({
  root: {
    padding: "20px 0",
    width: "100%",
  },

  box: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid #E7E9EB",
    background: "#FFFFFF",
    padding: "40px 44px",
    width: "644px",
    boxSizing: "border-box",
    margin: "auto",
  },

  title: {
    fontWeight: "bold",
    fontSize: "24px",
    marginBottom: "17px",
  },

  desc: {
    fontSize: "14px",
    marginBottom: "32px",
    textAlign: "left",
  },

  buttonContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
  },

  img: {
    width: "395px",
    marginBottom: "32px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

/**
 * Salesforce連携設定完了画面
 */
class SalesforceSettingComplete extends React.Component {
  render() {
    const { classes, dialogType, type } = this.props;

    let salesforceSettingDirectory;
    if (type === SalesforceSettingDirectory.ADDRESS_BOOK.value) {
      salesforceSettingDirectory = SalesforceSettingDirectory.ADDRESS_BOOK;
    } else if (type === SalesforceSettingDirectory.EXE_LIST.value) {
      salesforceSettingDirectory = SalesforceSettingDirectory.EXE_LIST;
    } else if (type === SalesforceSettingDirectory.TIMELINE_STATUS.value) {
      salesforceSettingDirectory = SalesforceSettingDirectory.TIMELINE_STATUS;
    } else {
      salesforceSettingDirectory = SalesforceSettingDirectory.ADDRESS_BOOK;
    }

    return (
      <div className={classes.root}>
        <div className={classes.box}>
          <picture>
            <source
              srcSet={require(`../../../../assets/images/Integrations.png`)}
              media="(max-width: 1023px)"
            />
            <source
              srcSet={require(`../../../../assets/images/Integrations@2x.png`)}
              media="(min-width: 1024px)"
            />
            <img
              className={classes.img}
              srcSet={require(`../../../../assets/images/Integrations@2x.png`)}
              alt="Integrations"
            />
          </picture>
          <Typography variant="title" className={classes.title}>
            {dialogType === DialogType.CREATE
              ? `${salesforceSettingDirectory.text}連携設定が完了しました！`
              : `${salesforceSettingDirectory.text}連携設定が更新されました！`}
          </Typography>
          <div>
            <Typography variant="body2" className={classes.desc}>
              {salesforceSettingDirectory.complete_desc}
            </Typography>

            {(salesforceSettingDirectory.value === SalesforceSettingDirectory.ADDRESS_BOOK.value || salesforceSettingDirectory.value === SalesforceSettingDirectory.EXE_LIST.value) && (
              <Typography variant="body2" className={classes.desc}>
                {(salesforceSettingDirectory.value === SalesforceSettingDirectory.ADDRESS_BOOK.value) ? SalesforceSettingDirectory.EXE_LIST.text : SalesforceSettingDirectory.ADDRESS_BOOK.text}連携の設定が完了していない場合、
                <Link
                  to={(salesforceSettingDirectory.value === SalesforceSettingDirectory.ADDRESS_BOOK.value) ? SalesforceSettingDirectory.EXE_LIST.setup_path : SalesforceSettingDirectory.ADDRESS_BOOK.setup_path}
                  className={classes.link}
                >
                  こちら
                </Link>
                から設定できます。
              </Typography>
            )}
          </div>
          <div className={classes.buttonContainer}>
            <Button
              text="Salesforce連携設定へ"
              type="line"
              style={{
                marginRight: "10px",
              }}
              handleClickButton={() =>
                this.props.goTo("/setting/integrations/salesforce")
              }
            />
            {(() => {
              if (salesforceSettingDirectory.value === SalesforceSettingDirectory.ADDRESS_BOOK.value) {
                return (
                  <Button
                    text="同期"
                    loading={this.props.isJobCompletedLoading}
                    handleClickButton={this.props.postSalesforceSync}
                  />
                );
              } else {
                return (
                  <Button
                    text="注文履歴へ"
                    loading={this.props.isJobCompletedLoading}
                    handleClickButton={() =>
                      this.props.goTo("/orders")
                    }
                  />
                );
              }
            })()}
          </div>
        </div>
      </div>
    );
  }
}

SalesforceSettingComplete.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogType: PropTypes.number,
  type: PropTypes.number,
  goTo: PropTypes.func,
  postSalesforceSync: PropTypes.func, // 自社リストの設定のときしか使わないのでpropsから渡されない場合がある
  isJobCompletedLoading: PropTypes.bool,
};

// @see 空を返してますが、エラーが発生するのでmapStateToPropsにconnectする必要があります。
const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goTo(url, state) {
      dispatch(push(url, state));
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceSettingComplete));



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/SalesforceSettingComplete.jsx